export const formItems = [
  {
    label: "Email",
    name: "email",
    formType: "input",
    // placeholder: "",
  },
  {
    label: "Order Number",
    name: "order_number",
    formType: "input",
    // placeholder: "e.g. 0000000000",
  },
  {
    label: "Order Date",
    name: "order_date",
    formType: "input",
    // placeholder: "e.g. Aug 01, 2023",
  },
  {
    label: "Delivery Date",
    name: "delivery_date",
    formType: "input",
    // placeholder: "e.g. Mon, Aug 01",
  },
  {
    label: "Image Link",
    name: "image_link",
    formType: "input",
    // placeholder: "",
  },
  {
    label: "Item",
    name: "item",
    formType: "input",
    // placeholder: "",
  },
  {
    label: "Full Name",
    name: "full_name",
    formType: "input",
    // placeholder: "",
  },
  {
    label: "Last 2 Phone Number Digits",
    name: "last_2_phone_number",
    formType: "input",
    // placeholder: "",
  },
  {
    label: "Street",
    name: "street",
    formType: "input",
    // placeholder: "",
  },
  {
    label: "City",
    name: "city",
    formType: "input",
    // placeholder: "",
  },
  {
    label: "ZIP",
    name: "zip",
    formType: "input",
    // placeholder: "",
  },
  {
    label: "Country",
    name: "country",
    formType: "input",
    // placeholder: "",
  },
  {
    label: "Subtotal",
    name: "subtotal",
    formType: "input",
    // placeholder: "e.g. $100.00",
  },
  {
    label: "Shipping",
    name: "shipping",
    formType: "input",
    // placeholder: "e.g. $0.00",
  },
  {
    label: "Tax",
    name: "tax",
    formType: "input",
    // placeholder: "e.g. $0.00",
  },
  {
    label: "Total",
    name: "total",
    formType: "input",
    // placeholder: "e.g. $100.00",
  },
  {
    label: "Color",
    name: "color",
    formType: "input",
    // placeholder: "",
  },
  {
    label: "Size",
    name: "size",
    formType: "input",
    // placeholder: "",
  },
  {
    label: "Taxes",
    name: "taxes",
    formType: "input",
    // placeholder: "e.g. $50.00",
  },
  {
    label: "Discount",
    name: "discount",
    formType: "input",
    // placeholder: "e.g. $0.00",
  },
  {
    label: "ETA",
    name: "eta",
    formType: "input",
    // placeholder: "e.g. Mon 1 Jan",
  },
  {
    label: "Language",
    name: "language",
    formType: "select",
    options: [
      {
        key: "en",
        value: "English",
      },
      {
        key: "de",
        value: "Deutsch",
      },
    ],
    default: "en",
  },
  {
    label: "Estimated delivery from",
    name: "estimated_delivery_from",
    formType: "input",
    // placeholder: "e.g. 01/01/2023",
  },
  {
    label: "Estimated delivery to",
    name: "estimated_delivery_to",
    formType: "input",
    // placeholder: "e.g. 01/01/2023",
  },
  {
    label: "Shipped from",
    name: "shipped_from",
    formType: "input",
    // placeholder: "e.g. Italy",
  },
  {
    label: "Brand",
    name: "brand",
    formType: "input",
    // placeholder: "e.g. Italy",
  },
  {
    label: "Credit",
    name: "credit",
    formType: "input",
    // placeholder: "e.g. $0.00",
  },
  {
    label: "Promotions",
    name: "promotions",
    formType: "input",
    // placeholder: "e.g. $0.00",
  },
  {
    label: "Reference Number",
    name: "reference_number",
    formType: "input",
    // placeholder: "",
  },
  {
    label: "Style ID",
    name: "style_id",
    formType: "input",
    // placeholder: "",
  },
  {
    label: "Item Name",
    name: "item_name",
    formType: "input",
    // placeholder: "",
  },
  {
    label: "Shoe Condition",
    name: "shoe_condition",
    formType: "input",
    // placeholder: "",
  },
  {
    label: "Box Condition",
    name: "box_condition",
    formType: "input",
    // placeholder: "",
  },
  {
    label: "GOAT Credit",
    name: "goat_credit",
    formType: "input",
    // placeholder: "e.g. $0.00",
  },
  {
    label: "Seller Location",
    name: "seller_location",
    formType: "input",
    // placeholder: "e.g. United States",
  },
  {
    label: "Seller Profile Picture Image Link",
    name: "seller_profile_image_link",
    formType: "input",
    // placeholder: "",
  },
  {
    label: "Payment Method",
    name: "payment_method",
    formType: "input",
    // placeholder: "e.g. Paypal",
  },
  {
    label: "Item Link (Without Prefix)",
    name: "item_link",
    formType: "input",
    // placeholder: "e.g. stockx.com/",
  },
  {
    label: "Size in brackets",
    name: "size_in_brackets",
    formType: "input",
    // placeholder: "e.g. (Size 10)",
  },
  {
    label: "Purchase Price",
    name: "purchase_price",
    formType: "input",
    // placeholder: "e.g. $1,000",
  },
  {
    label: "Tax Options",
    name: "tax_options",
    formType: "select",
    options: [
      {
        key: "sales",
        value: "Sales Tax",
      },
      {
        key: "vat",
        value: "VAT",
      },
    ],
    default: "sales",
  },
  {
    label: "Amount",
    name: "amount",
    formType: "input",
    // placeholder: "e.g. $50",
  },
  {
    label: "Processing Fee",
    name: "processing_fee",
    formType: "input",
    // placeholder: "e.g. $100",
  },
  {
    label: "Last 4 Digits Of Credit Card",
    name: "last_4_credit_card",
    formType: "input",
    // placeholder: "e.g. 1234",
  },
];
